import Vue from 'vue'
import Vuex from 'vuex'
import createMutationsSharer from 'vuex-shared-mutations'

import adminStore from './admin'
import adsStore from './ads'
import airlinesStore from './airlines'
import airportsStore from './airports'
import brandsStore from './brands'
import consumerStore from './consumer/index'
import corporateStore from './corporate/index'
import countryCodeStore from './country-code'
import coverageStore from './coverage/index'
import dispatchStore from './dispatch/index'
import filtersStore from './filters/index'
import flightInformationStore from './flight-information-modal'
import geofenceStore from './geofences/index'
import laxitStore from './laxit/index'
import notificationPermissionStore from './notification-permission'
import packageStore from './package-details'
import phoneAppStore from './phone-app'
import pricingStore from './pricing'
import promoStore from './promo'
import providerStore from './provider'
import providerDeductionStore from './provider-deductions'
import refundCreditStore from './refund-credit-modal'
import reportsStore from './reports'
import reservationStore from './reservation/index'
import reservationNotesStore from './reservation-notes-modal'
import routingStore from './routing/index'
import rsvpDetailsStore from './reservation-details/index'
import searchGlobalStore from './search-global'
import servicesStore from './services'
import sessionStore from './session'
import settingsStore from './settings'
import settingsPageStore from './settings-page'
import sideMenuStore from './side-menu'
import transactionsStore from './transactions'
import runsStore from './runs'
import discountCodes from './discount-codes'
import global from './global'
import cancelUpcoming from './cancel-upcoming'
import flights from './flights'
import flightDetails from './flight-details'
import currency from './currency'
import lyft from './lyft'
import insurance from './insurance'

Vue.use(Vuex)

// Build Shared mutations
let sharedMutations = []
sharedMutations = sharedMutations.concat(consumerStore.sharedMutations)
sharedMutations = sharedMutations.concat(dispatchStore.sharedMutations)
sharedMutations = sharedMutations.concat(reservationStore.sharedMutations)
sharedMutations = sharedMutations.concat(rsvpDetailsStore.sharedMutations)
sharedMutations = sharedMutations.concat(phoneAppStore.sharedMutations)
sharedMutations = sharedMutations.concat(sessionStore.sharedMutations)
sharedMutations = sharedMutations.concat(geofenceStore.sharedMutations)

let store = new Vuex.Store({
  plugins: [
    createMutationsSharer(
      {
        predicate: sharedMutations
      }
    )
  ],
  modules: {
    admin: adminStore,
    ads: adsStore,
    airlines: airlinesStore,
    airports: airportsStore,
    brands: brandsStore,
    consumer: consumerStore,
    corporate: corporateStore,
    countryCode: countryCodeStore,
    coverage: coverageStore,
    dispatch: dispatchStore,
    filters: filtersStore,
    flightInformation: flightInformationStore,
    geofences: geofenceStore,
    laxit: laxitStore,
    notificationPermission: notificationPermissionStore,
    packageDetails: packageStore,
    phone: phoneAppStore,
    pricing: pricingStore,
    promo: promoStore,
    provider: providerStore,
    providerDeductions: providerDeductionStore,
    refundCredit: refundCreditStore,
    reports: reportsStore,
    reservation: reservationStore,
    reservationNotes: reservationNotesStore,
    routing: routingStore,
    rsvpDetails: rsvpDetailsStore,
    searchGlobal: searchGlobalStore,
    services: servicesStore,
    session: sessionStore,
    settings: settingsStore,
    settingsPage: settingsPageStore,
    sideMenu: sideMenuStore,
    transactions: transactionsStore,
    runs: runsStore,
    discountCodes: discountCodes,
    global: global,
    cancelUpcoming: cancelUpcoming,
    flights: flights,
    flightDetails: flightDetails,
    currency: currency,
    lyft: lyft,
    insurance: insurance,
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js